import React from 'react';
import { SkeletonBar } from '../../ui/Skeleton/SkeletonBar';

// Holds the notice line's slot while the check is in flight, so the line does not push the list down once
// the page has settled. The box is one text line tall, matching the real notice.
export const TransphereUnappliedIndicatorSkeleton: React.FC = () => (
    <div data-testid="transphere-indicator-skeleton" aria-hidden="true" className="flex h-5 items-center">
        <SkeletonBar className="h-4 w-72" />
    </div>
);
